module.exports = __webpack_public_path__ + "img/red_back.b27beff2.png";